<script setup lang="ts">
import './assets/style.scss'
import { useScheduleDelete } from './../model/api.ts'
import { useConfirm } from '@/shared/ui'
import { useTranslate } from '@/shared/lib'
import type { PropType } from 'vue'
import type { ScheduleTreeItemType } from '@/entities/SchedulesTree/model/types.ts'

const props = defineProps({
  schedule: {
    type: Object as PropType<ScheduleTreeItemType>,
    required: true,
  },
})

const { remove } = useScheduleDelete()
const { show } = useConfirm()
const { trs } = useTranslate()

const clickHandler = () => {
  show({
    content: trs('itf.schedules_deleted_submit'),
    confirmFunc: () => {
      if (props.schedule) return remove(props.schedule)
    },
  })
}
</script>

<template>
  <div @click="clickHandler">
    <slot />
  </div>
</template>
